import { Outlet } from 'react-router-dom';
import { SemanticLayerQuickNav } from '../../components/SemanticLayerQuickNav';

/**
 * Route layout shared by every Semantic Layer screen — list and detail alike. The quick nav
 * sits on the left and the routed page renders to its right, so the nav keeps its scroll
 * position and search across navigations. There's no layout-level header: pages own the top
 * of that pane (title, actions) and are expected to fill it: `flex-1 min-h-0 flex flex-col`.
 */
export default function SemanticLayerLayout() {
  return (
    <div className="w-full flex flex-col bg-background overflow-hidden" style={{ height: 'calc(100vh)' }}>
      <div className="flex-1 min-h-0 overflow-hidden flex">
        <SemanticLayerQuickNav />
        <div className="flex-1 min-h-0 overflow-hidden flex flex-col">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
